import { motion } from "framer-motion";
import { ArrowRightCircle } from "lucide-react";
import Button from "../components/Button";

function Head() {

    const openWebsite = (url) => {
        const link = document.createElement("a");
        link.href = url;
        link.hidden = true;
        link.target = "_blank";
        link.rel = "noopener noreferrer";
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };
    
    return (
        <div className="relative w-full h-[50vh] overflow-hidden bg-gradient-to-r from-yellow-200 to-orange-400 flex flex-col items-center justify-center text-black pt-50 pb-50">
            <motion.svg
                className="absolute bottom-0 left-0 w-full"
                viewBox="0 0 1440 320"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                initial={{ opacity: 0, y: 150 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 1.0, delay: 0.2 }}
            >
            <defs>
              <linearGradient id="gradient" x1="0" y1="0" x2="1" y2="0">
                <stop offset="0%" stop-color="#fb923c" />
                <stop offset="100%" stop-color="#fef08a" />
              </linearGradient>
            </defs>
                <path
                    fill="url(#gradient"
                    fillOpacity="1"
                    d="M0,192L30,170.7C60,149,120,107,180,117.3C240,128,300,192,360,181.3C420,171,480,85,540,90.7C600,96,660,192,720,224C780,256,840,224,900,192C960,160,1020,128,1080,133.3C1140,139,1200,181,1260,192C1320,203,1380,181,1410,170.7L1440,160L1440,320L1410,320C1380,320,1320,320,1260,320C1200,320,1140,320,1080,320C1020,320,960,320,900,320C840,320,780,320,720,320C660,320,600,320,540,320C480,320,420,320,360,320C300,320,240,320,180,320C120,320,60,320,30,320L0,320Z"
                />
            </motion.svg>
            <motion.div
                initial={{ opacity: 0, y: 40 }}
                animate={{ opacity: 1, y: 0, z: 5 }}
                transition={{ duration: 1 }}
                className="text-center"
            >
                <h1 className="text-5xl mb-3 font-bold drop-shadow-lg">William Katz</h1>
                <h2 className="text-xl drop-shadow-lg mb-6">Student & Full-Stack & AI Developer</h2>
                <div className="grid grid-calls-1 sm:grid-cols-2 md:grid-cols-3 gap-4 justify-center">
                    <Button style={{ cursor: 'pointer' }} onClick={_ => openWebsite('https://www.linkedin.com/in/william-katz-481199288/')} className="bg-gray-200 text-orange-600 hover:bg-gray-300 font-semibold px-6 py-3 flex items-center gap-2 justify-center">
                        LinkedIn
                        <ArrowRightCircle size={20} />
                    </Button>
                    <Button style={{ cursor: 'pointer' }} onClick={_ => openWebsite('https://github.com/will-katz')} className="bg-gray-200 text-orange-600 hover:bg-gray-300 font-semibold px-6 py-3 flex items-center gap-2 justify-center">
                        GitHub
                        <ArrowRightCircle size={20} />
                    </Button>
                    <Button style={{ cursor: 'pointer' }} onClick={(e) => openWebsite('mailto:william.katz@me.com')} className="bg-gray-200 text-orange-600 hover:bg-gray-300 font-semibold px-6 py-3 flex items-center gap-2 justify-center">
                        Email
                        <ArrowRightCircle size={20} />
                    </Button>
                </div>
            </motion.div>
        </div>
    );
};

export default Head;